import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Banner from "../components/botanical/banner"
import Intro from "../components/botanical/intro"
import IntroTwo from "../components/botanical/intro-two"
import Video from "../components/botanical/video"
import Results from "../components/botanical/results"
import Steps from "../components/botanical/steps"
import Happens from "../components/botanical/happens"
import Included from "../components/botanical/included"
import Boxes from "../components/botanical/boxes"
import Need from "../components/botanical/need"

import Testimonial from "../components/testimonials/testimonial"
import { graphql } from "gatsby"

export const query = graphql`
  {
    strapiBotanicalReset {
      Seo {
        metaTitle
        metaDescription
        keywords
      }
      BannerHeading
      BannerSubHeading
      BannerCtas {
        ButtonText
        ButtonLink
      }
      IntroSection {
        Heading
        Body
        Image {
          publicURL
        }
      }
      IntroTwoSection {
        Heading
        Body
        Image {
          publicURL
        }
      }
      StepsHeading
      StepsBody
      Steps {
        Heading
        Body
      }
      IncludedSection {
        Heading
        Body
        Image {
          publicURL
        }
        Buttons {
          ButtonText
          ButtonLink
        }
      }
      ResultsSection {
        Heading
        Body
        Image {
          publicURL
        }
      }
      HappensSection {
        Heading
        Body
        Image {
          publicURL
        }
      }
      NeedSection {
        Heading
      }
      NeedBoxes {
        ButtonText
        ButtonLink
        Text
        Image {
          publicURL
        }
      }
      Boxes {
        Text
        Image {
          publicURL
        }
        ButtonText
        ButtonLink
      }
      Testimonials {
        Body
        Name
        Image {
          publicURL
        }
      }
    }
  }
`
const BotanicalReset = ({ data }) => {
  return (
    <Layout slug={`/botanical-reset`}>
      <Seo
        title={data.strapiBotanicalReset.Seo.metaTitle}
        description={data.strapiBotanicalReset.Seo.metaDescription}
        keywords={data.strapiBotanicalReset.Seo.keywords}
      />
      <Banner data={data}></Banner>
      <Intro data={data}></Intro>
      <IntroTwo data={data}></IntroTwo>
      <Steps data={data}></Steps>
      <Included data={data}></Included>
      <Video data={data}></Video>
      <Results data={data}></Results>
      <Testimonial
        data={data.strapiBotanicalReset.Testimonials[0]}
      ></Testimonial>
      <Happens data={data}></Happens>
      <Need data={data}></Need>
      <Boxes data={data.strapiBotanicalReset.Boxes}></Boxes>
    </Layout>
  )
}

export default BotanicalReset
